import QRCode from "react-qr-code";
import { useState } from "react";

const QRPage = () => {
    const[qrCode,setQrCode]=useState("https://rozetka.com.ua/ua/asus-90nr0na1-m00ea0/p601756117/?gad_source=1&gad_campaignid=23516836960&gbraid=0AAAAABpmbmuA6reHAIHlMMk2kiQ9OD1W1&gclid=CjwKCAjwtKrUBhAhEiwAr77ZosavUytbMUTez9yaGQU-VXJK7CeT019yTiNsvKQ9d_42xGQ7b5RXTBoCo-oQAvD_BwE")
    //console.log("qrCode", qrCode);
     
        const onChangeInput = (e) => {
        // e - це сам input - у якому відбуваються зміниї
        //Подія яка спрацьовує коли дані у input змінюються
        setQrCode(e.target.value); //Суди передаємо значення, яке є input на даний момент
    }


    return (
        
     <div className="container">
        <div className={"col-md-8 offset-md-2 mt-2"}>
             <h1 className={"text-center"}>Генерація QR кодів</h1>
                <div className="mb-3">
                    <label htmlFor="myInputQR" className="form-label">Вкажіть посилання на сайт</label>
                    <input type="text"
                           className="form-control"
                           id="myInputQR"
                           value = {qrCode}
                           onChange={onChangeInput}
                    />
                </div>
                <QRCode value={qrCode}/>
            </div>
        </div>
    )
}

export default QRPage;




